module.exports = __webpack_public_path__ + "static/french_circle_4-c99daf8a45cb1dbf7658a1beba325085.svg";